export default __webpack_public_path__ + "static/media/project02.146521f4.png";